import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

const tasAssistancesUrl = (path?: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'tas-assistances' },
    op: 'query',
    resourcePath: 'tas-assistances',
  };
  const base = buildBaseURL(opts);
  return path ? `${base}/${path.replace(/^\/+/, '')}` : base;
};

/**
 * PATCH /tas-assistances/:id/update-amount — adjust tuition / gross amount
 * with an audit reason. `grossAmount` only attached when defined to
 * preserve the legacy adapter's optional-field shape.
 */
export function updateTasAssistanceAmountRequest(
  tasAssistanceId: string,
  amount: number,
  reason: string,
  grossAmount?: number
): RequestInfo {
  const body: Record<string, unknown> = { amount, reason };
  if (grossAmount !== undefined) {
    body['gross_amount'] = grossAmount;
  }
  return {
    url: tasAssistancesUrl(`${tasAssistanceId}/update-amount`),
    method: 'PATCH',
    body: JSON.stringify(body),
    cacheOptions: { [SkipCache]: true },
  };
}

/**
 * PATCH /tas-assistances/:id/transition/state/settle — test-only path to
 * force-settle an assistance.
 */
export function settleTasAssistanceRequest(tasAssistanceId: string): RequestInfo {
  return {
    url: tasAssistancesUrl(`${tasAssistanceId}/transition/state/settle`),
    method: 'PATCH',
    cacheOptions: { [SkipCache]: true },
  };
}
